<template>
  <el-select
    v-if="customer"
    ref="delivery"
    clearable
    filterable
    remote
    :remote-method="search"
    v-model="selected"
    v-loading="loading"
    placeholder="Selecione  uma opção"
    @change="update()"
    @clear="clear()"
  >
    <el-option
      v-for="row of filterable"
      :key="row.id"
      :label="row.name"
      :value="row.id"
    ></el-option>
  </el-select>
  <span v-else>Nenhum cliente selecionado</span>
</template>

<script>
import { DeliveryService } from "@/services/delivery/delivery.services";
export default {
  name: "DepartmentList",
  props: ["customer", "licence"],
  data: function () {
    return {
      departments: [],
      filterable: [],
      selected: "",
      loading: false
    };
  },
  watch: {
    customer: function (v) {
      const vm = this;
      console.log('watch delivery customer', v);
      vm.fetchDepartment();
    },
    licence: function (v) {
      const vm = this;
      console.log('watch delivery licence', v);
    },
  },
  methods: {
    getSearchValue(row, path) {
      return path
        .reduce((value, key) => (value && value[key] ? value[key] : ""), row)
        .toString()
        .toLowerCase();
    },
    search(query) {
      const vm = this;
      if (query) {
        const search = query.toLowerCase();
        vm.filterable = vm.departments.filter(x =>
          vm.getSearchValue(x, ["name"]).includes(search) ||
          vm.getSearchValue(x, ["zipcode", "address"]).includes(search) ||
          vm.getSearchValue(x, ["zipcode", "city"]).includes(search) ||
          vm.getSearchValue(x, ["zipcode", "neighborhood"]).includes(search) ||
          vm.getSearchValue(x, ["zipcode", "zipcode"]).includes(search));
      } else {
        vm.filterable = vm.departments;
      }
      this.query = query;
    },
    fetchDepartment() {
      const vm = this;
      if (!vm.$props.customer) {
        return false;
      }
      vm.loading = true;
      DeliveryService.listByCustomer(vm.$props.customer)
        .then((response) => {
          vm.departments = response.records || [];
          vm.filterable = vm.departments;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => (vm.loading = false));
    },
    update() {
      const vm = this;
      vm.$emit("input", vm.selected);
      vm.$emit("selected", vm.selected);
    },
    clear() {
      const vm = this;
      vm.filterable = vm.departments;
      vm.$emit("clear");
    },
  },
  mounted() {
    const vm = this;
    console.log('mount delivery list')
    vm.fetchDepartment();
  },
};
</script>
